var _g, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIso27001(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179 176",
    width: 179,
    height: 176,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#221463",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 72,
    r: 56,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.5,
    cy: 72,
    rx: 20,
    ry: 56
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.5,
    cy: 72,
    rx: 40,
    ry: 56
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.5,
    cy: 72,
    rx: 56,
    ry: 20
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.5,
    cy: 72,
    rx: 56,
    ry: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.5,
    y1: 72,
    x2: 145.5,
    y2: 72
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 89.5,
    y: 90,
    fill: "#221463",
    stroke: "#FFFFFF",
    strokeWidth: 6,
    paintOrder: "stroke",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 52,
    fontWeight: "bold",
    letterSpacing: 1,
    textAnchor: "middle"
  }, "ISO")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 89.5,
    y: 162,
    fill: "#221463",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 30,
    fontWeight: "bold",
    letterSpacing: 1,
    textAnchor: "middle"
  }, "27001")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIso27001);
export default __webpack_public_path__ + "static/media/ISO-27001.400900fff5a92c775a5b79e6a6d67845.svg";
export { ForwardRef as ReactComponent };